import * as React from "react";
import { adminGetModels, deleteCharacter } from "../../../api/rest-apis";
import DeleteModal from "../../../helpers/delete-modal";
import { toastHelper } from "../../../helpers/toast";
import "../css/assistant.css";
import AssistantFileUpload from "../helpers/assistant-file-upload";
import { File } from "../interfaces/file";
import CustomPromptModal from "./assistant-custom-response";
import CombinedDragAndDropComponent from "../helpers/drag-drop";
import DragDrop from "../helpers/drag-drop";
import { act } from "react-dom/test-utils";

interface Assistant {
  _id?: string;
  assistant_type: string;
  assistant_id?: string;
  instructions: string;
  model: string;
  tools: { type: string }[];
  greeting: string;
  sample_prompts: string[];
  configurations: { name: string; instructions: string }[];
  reasoning_effort: string;
  files: File[];
  for_plan: string[];
  tab_name: string;
}

interface AssistantFormProps {
  reverseFunction: (assistants: any) => any;
  handleSubmit: () => any;
  assistants: Assistant[];
  characterId: string;
  booksTalk: boolean;
}

interface AssistantFormState {
  assistants: Assistant[];
  activeTab: number;
  currentPrompts: string[];
  tabs: string[];
  modelList: any;
  showDeleteModal: boolean;
  deleteAssistantId: string | undefined;
  customPromptOpen: boolean;
  CustomPromptActive: string;
  CustomPromptActiveAssistant: string;
  showAIProviderModal: boolean;
  selectedAIProvider: any;
}

class AssistantForm extends React.Component<
  AssistantFormProps,
  AssistantFormState
> {
  state = {
    showAIProviderModal: false,
    selectedAIProvider: null, // or default it to 'xai'
    assistants: [],
    activeTab: 0,
    currentPrompts: [""],
    tabs: [],
    modelList: { openai: [], xai: [] },
    showDeleteModal: false,
    deleteAssistantId: "",
    currentlyEditingSamplePrompt: "",
    customPromptOpen: false,
    CustomPromptActive: "",
    CustomPromptActiveAssistant: "",
  };

  plans: string[] = ["basic", "plus", "premium"];

  plansMapper: any = {
    basic: "Subscriber",
    plus: "Patron",
    premium: "Premium",
  };

  constructor(props: any) {
    super(props);
    this.addTabWithProvider = this.addTabWithProvider.bind(this);
    this.deleteAssistant = this.deleteAssistant.bind(this);
  }

  async componentDidMount() {
    if (this.props.assistants.length > 0) {
      this.setState({
        assistants: this.props.assistants,
        tabs: this.props.assistants.map((assistant: any) => assistant.tab_name),
        activeTab: 0,
      });
    }

    try {
      const response: any = await adminGetModels();

      this.setState({ modelList: response });
    } catch (error) {
      console.error(error);
    }
  }

  componentDidUpdate(
    prevProps: Readonly<AssistantFormProps>,
    prevState: Readonly<AssistantFormState>,
    snapshot?: any
  ): void {
    const stateAssistants: Assistant[] = [...this.state.assistants];

    if (stateAssistants.length != prevProps.assistants.length) {
      // Note: If the state length is greather it's mean the user just add a new assistant. Not in the DB
      console.log("Length is different");
    }

    for (let index = 0; index < this.props.assistants.length; index++) {
      const assistant = this.props.assistants[index];

      if (
        stateAssistants.length === this.props.assistants.length &&
        (assistant._id !== stateAssistants[index]._id ||
          assistant.assistant_id !== stateAssistants[index].assistant_id)
      ) {
        this.setState({
          assistants: this.props.assistants,
          tabs: this.props.assistants.map(
            (assistant: any) => assistant.tab_name
          ),
          activeTab: 0,
        });
      }
    }
  }

  addTabWithProvider(provider: "xai" | "openai") {
    const newAssistant = {
      greeting: "",
      instructions: "",
      assistant_type: provider,
      reasoning_effort: "",
      model: "",
      tools: [],
      configurations: [],
      sample_prompts: [
        "Sample Prompt goes like this",
        "Sample Prompt goes like this",
      ],
      files: [],
      for_plan: [],
      tab_name: `New Assistant ${this.state.tabs.length}`,
    };

    const assistants: Assistant[] = [...this.state.assistants, newAssistant];
    const tabs: string[] = [...this.state.tabs, newAssistant.tab_name];
    const activeTab = tabs.length - 1;

    this.setState({
      assistants,
      tabs,
      activeTab,
      showAIProviderModal: false,
    });

    this.props.reverseFunction(assistants);
  }

  async deleteAssistant() {
    const id = toastHelper.loading("Deleting ...");
    try {
      const arr: Assistant[] = [...this.state.assistants];

      arr.splice(this.state.activeTab, 1);

      if (arr.length === 0) {
        const newAssistant: any = {
          greeting: "",
          instructions: "",
          assistant_type: "xai",
          model: "",
          tools: [],
          files: [],
          sample_prompts: [],
          configuration: [],
          for_plan: [],
          tab_name: "New Assistant",
        };

        arr.push(newAssistant);
      }

      if (this.state.deleteAssistantId === undefined) {
        this.props.reverseFunction(arr);

        this.setState({
          showDeleteModal: false,
          deleteAssistantId: "",
          activeTab: arr.length - 1,
          assistants: arr,
          tabs: arr.map((assistant: any) => assistant.tab_name),
        });

        toastHelper.success("Assistant have been deleted!", id);
        return;
      }

      await deleteCharacter(
        this.props.characterId,
        this.state.deleteAssistantId
      );

      toastHelper.success("Assistant have been deleted!", id);

      this.props.reverseFunction(arr);

      this.setState({
        showDeleteModal: false,
        deleteAssistantId: "",
        activeTab: arr.length - 1,
        assistants: arr,
        tabs: arr.map((assistant: any) => assistant.tab_name),
      });
      setTimeout(async () => await this.componentDidMount(), 500);
    } catch (error) {
      toastHelper.error("Error on deleting assistant", id);
      console.error(error);
      this.setState({ showDeleteModal: false, deleteAssistantId: "" });
    }
  }

  handleTabClick(index: number) {
    this.setState({ activeTab: index });
  }

  handleInputChange = (field: string, value: string) => {
    setTimeout(
      () =>
        this.setState({
          tabs: this.state.assistants.map(
            (assistant: any) => assistant.tab_name
          ),
        }),
      100
    );

    this.setState((prevState: any) => {
      const assistants = [...prevState.assistants];
      assistants[prevState.activeTab][field] = value;
      return { assistants };
    });

    this.props.reverseFunction(this.state.assistants);
  };

  removeSamplePrompt(index: number): void {
    const assistants: Assistant[] = [...this.state.assistants];
    assistants[this.state.activeTab].sample_prompts.splice(index, 1);
    this.setState({ assistants });
  }

  handleAddSamplePrompt = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      const currentPrompts: string[] = [...this.state.currentPrompts];
      const assistants: Assistant[] = [...this.state.assistants];
      assistants[this.state.activeTab].sample_prompts.push(
        currentPrompts[this.state.activeTab]
      );
      if (currentPrompts[this.state.activeTab].trim() !== "") {
        this.setState({ assistants });
      }
      setTimeout(() => this.props.handleSubmit(), 1000);
    }
  };

  handlePromptInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const currentPrompts: string[] = [...this.state.currentPrompts];
    currentPrompts[this.state.activeTab] = event.target.value;
    this.setState({ currentPrompts });
  };

  toggleTool(toolType: any) {
    this.setState((prevState: any) => {
      const assistants = [...prevState.assistants];
      const tools = assistants[prevState.activeTab].tools;
      const toolIndex = tools.findIndex((tool: any) => tool.type === toolType);

      if (toolIndex > -1) {
        // Tool exists, remove it
        tools.splice(toolIndex, 1);
      } else {
        // Tool doesn't exist, add it
        tools.push({ type: toolType });
      }

      return { assistants };
    });

    this.props.reverseFunction(this.state.assistants);
  }

  addConfiguration = () => {
    this.setState(
      (prevState) => {
        const assistants: any = [...prevState.assistants];
        assistants[prevState.activeTab].configurations.push({
          name: "",
          instructions: "",
        });
        return { assistants };
      },
      () => this.props.reverseFunction(this.state.assistants)
    );
  };

  handleConfigurationChange = (index: number, field: string, value: string) => {
    this.setState(
      (prevState) => {
        const assistants: any = [...prevState.assistants];
        const configs: any = [
          ...assistants[prevState.activeTab].configurations,
        ];
        configs[index][field] = value;
        assistants[prevState.activeTab].configurations = configs;
        return { assistants };
      },
      () => this.props.reverseFunction(this.state.assistants)
    );
  };

  handleFilesChange(files: any) {
    this.setState((prevState: any) => {
      const assistants = [...prevState.assistants];
      assistants[prevState.activeTab].files = files;
      return { assistants };
    });

    this.props.reverseFunction(this.state.assistants);
    setTimeout(() => this.props.handleSubmit(), 1000);
  }

  togglePlan(plan: any) {
    this.setState((prevState: any) => {
      const assistants = [...prevState.assistants];
      const currentPlans = assistants[prevState.activeTab].for_plan;
      const planIndex = currentPlans.indexOf(plan);

      if (planIndex > -1) {
        // Plan exists, remove it
        currentPlans.splice(planIndex, 1);
      } else {
        // Plan doesn't exist, add it
        currentPlans.push(plan);
      }

      return { assistants };
    });

    this.props.reverseFunction(this.state.assistants);
  }

  removeConfiguration(index: number) {
    const assistants: any = this.state.assistants;
    const activeTab = this.state.activeTab;

    // Clone the active assistant from the assistants array to avoid direct mutation
    const activeAssistant: any = { ...assistants[activeTab] };

    // Create a new configurations array and remove the configuration at the given index
    const newConfigurations = [...activeAssistant.configurations];
    newConfigurations.splice(index, 1);
    activeAssistant.configurations = newConfigurations;

    // Clone the entire assistants array, then update the active assistant entry
    const updatedAssistants: any = [...assistants];
    updatedAssistants[activeTab] = activeAssistant;

    // Update the state with the new assistants array
    this.setState({
      assistants: updatedAssistants,
    });

    this.props.reverseFunction(updatedAssistants);
  }

  handleReorder = (updatedList: string[]) => {
    // console.log(this.state.currentPrompts);
    console.log("Hello", updatedList);
    const currentPrompts: string[] = [...updatedList];
    const assistants: Assistant[] = [...this.state.assistants];
    assistants[this.state.activeTab].sample_prompts = currentPrompts;

    if (currentPrompts[this.state.activeTab].trim() !== "") {
      this.setState({ assistants });
    }
  };

  renderAIProviderModal() {
    if (!this.state.showAIProviderModal) return null;

    return (
      <div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
        onClick={() => this.setState({ showAIProviderModal: false })}
      >
        <div
          className="bg-white p-6 rounded-2xl shadow-2xl w-full max-w-sm mx-auto transform transition-all"
          onClick={(e) => e.stopPropagation()}
        >
          <h2 className="text-xl font-semibold mb-6 text-center text-gray-800">
            Choose AI Provider
          </h2>
          <div className="flex flex-col gap-4">
            <button
              className="bg-[#f53e61] text-white py-2 px-4 rounded-md hover:opacity-90 transition"
              onClick={() => this.addTabWithProvider("xai")}
            >
              XAI
            </button>
            <button
              className="bg-[#f6f2f4] text-black py-2 px-4 rounded-md border hover:opacity-90 transition"
              onClick={() => this.addTabWithProvider("openai")}
            >
              OpenAI
            </button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { activeTab, assistants, modelList, tabs, showDeleteModal } =
      this.state;
    const activeAssistant: Assistant = assistants[activeTab];

    return (
      <div className="mt-8">
        {this.renderAIProviderModal()}
        <p className="bookish-input-label">
          {this.props.booksTalk ? "Book Talk" : "Assistants"}
        </p>
        <div className="assistants-edit">
          <div className="tabs flex">
            {tabs.map((tab, index) => (
              <div
                key={index}
                className={`tab flex items-center ${
                  activeTab === index ? "active-tab" : ""
                }`}
                onClick={() => this.handleTabClick(index)}
              >
                {tab}
              </div>
            ))}
            <div
              className="tab flex items-center"
              onClick={() => this.setState({ showAIProviderModal: true })}
            >
              <img src="/assets/images/plus.svg" alt="" />
              <span className="ml-2">Add Assistant</span>
            </div>
          </div>

          {this.state.tabs.length > 0 && (
            <div className="tab-content">
              <div className="delete-btn flex justify-end">
                <button
                  onClick={() =>
                    this.setState({
                      showDeleteModal: true,
                      deleteAssistantId: activeAssistant.assistant_id,
                    })
                  }
                >
                  <img
                    className="edit-icon"
                    src="/assets/images/delete-red.svg"
                    alt=""
                  />
                </button>
              </div>
              <div className="bookish-input-group mt-5">
                <p className="bookish-input-label">
                  Tab Name <span className="required">*</span>
                </p>
                <input
                  type="text"
                  className="bookish-input-field"
                  value={activeAssistant.tab_name}
                  onChange={(e) =>
                    this.handleInputChange("tab_name", e.target.value)
                  }
                />
              </div>
              <div className="bookish-input-group mt-5">
                <p className="bookish-input-label">
                  Greeting <span className="required">*</span>
                </p>
                <textarea
                  className="bookish-input-field bookish-character-textarea"
                  value={activeAssistant.greeting}
                  onChange={(e) =>
                    this.handleInputChange("greeting", e.target.value)
                  }
                  rows={4}
                />
              </div>
              <div className="bookish-input-group mt-5">
                <p className="bookish-input-label">
                  Instructions <span className="required">*</span>
                </p>
                <textarea
                  className="bookish-input-field bookish-character-textarea"
                  value={activeAssistant.instructions}
                  onChange={(e) =>
                    this.handleInputChange("instructions", e.target.value)
                  }
                  rows={4}
                />
              </div>

              <div className="bookish-input-group mt-7">
                <p className="bookish-input-label">
                  Model <span className="required">*</span>
                </p>
                <select
                  className="bookish-select-box"
                  value={activeAssistant.model}
                  onChange={(e) =>
                    this.handleInputChange("model", e.target.value)
                  }
                >
                  <optgroup label="xAI">
                    {this.state.modelList.xai.map(
                      (model: any, index: number) => (
                        <option key={`xai-${index}`} value={model.id}>
                          {model.id}
                        </option>
                      )
                    )}
                  </optgroup>

                  <optgroup label="OpenAI">
                    {this.state.modelList.openai.map(
                      (model: any, index: number) => (
                        <option key={`openai-${index}`} value={model.id}>
                          {model.id}
                        </option>
                      )
                    )}
                  </optgroup>
                </select>
              </div>

              {activeAssistant.model.startsWith("o") && (
                <div className="bookish-input-group mt-7">
                  <p className="bookish-input-label">
                    Reasoning effort <span className="required">*</span>
                  </p>
                  <select
                    className="bookish-select-box"
                    value={activeAssistant.reasoning_effort}
                    onChange={(e) =>
                      this.handleInputChange("reasoning_effort", e.target.value)
                    }
                  >
                    {["low", "medium", "high"].map(
                      (reasoning_effort: any, index: number) => (
                        <option
                          key={`reasoning_effort-${index}`}
                          value={reasoning_effort}
                        >
                          {reasoning_effort}
                        </option>
                      )
                    )}
                  </select>
                </div>
              )}

              {/* Configurations */}
              {activeAssistant.configurations &&
                (activeAssistant.assistant_type == "xai" ||
                  activeAssistant.model.startsWith("grok")) && (
                  <>
                    <div className="bookish-input-group mt-7">
                      {activeAssistant.configurations.length > 0 && (
                        <label className="bookish-input-label">RAG files</label>
                      )}

                      {activeAssistant.configurations.map(
                        (config: any, index: any) => (
                          <div
                            key={index}
                            className="flex flex-col my-3 p-4 border border-dotted border-blue-400 rounded-md"
                          >
                            <input
                              type="text"
                              className="bookish-input-field mb-2"
                              placeholder="File Name"
                              value={config.name}
                              onChange={(e) =>
                                this.handleConfigurationChange(
                                  index,
                                  "name",
                                  e.target.value
                                )
                              }
                            />
                            <textarea
                              className="bookish-input-field"
                              placeholder="Instructions"
                              value={config.instructions}
                              onChange={(e) =>
                                this.handleConfigurationChange(
                                  index,
                                  "instructions",
                                  e.target.value
                                )
                              }
                              rows={3}
                              cols={7}
                              style={{ width: "40rem" }}
                            />

                            {/* Remove Button */}
                            <button
                              type="button"
                              className="text-white bg-red-500 px-3 py-1 rounded-md hover:opacity-90 transition mt-2 self-end"
                              onClick={() => this.removeConfiguration(index)}
                            >
                              Remove
                            </button>
                          </div>
                        )
                      )}

                      <br />
                      <button
                        type="button"
                        className="text-[#fff] bg-[#f53e61] px-4 py-2 rounded-md hover:opacity-90 transition"
                        onClick={this.addConfiguration}
                      >
                        Add RAG function calling
                      </button>
                    </div>
                  </>
                )}

              {!activeAssistant.model.startsWith("grok") && (
                <>
                  <div className="bookish-input-group mt-7">
                    <p className="bookish-input-label">Tools</p>
                    <div
                      className="bookish-on-off flex"
                      onClick={() => this.toggleTool("file_search")}
                    >
                      <p className="label mt-1">Retrieval</p>
                      <div
                        className={`rectangle ml-auto ${
                          activeAssistant.tools.some(
                            (tool: any) => tool.type === "file_search"
                          )
                            ? "rectangle-active"
                            : ""
                        }`}
                      >
                        <div
                          className={`ellipse ${
                            activeAssistant.tools.some(
                              (tool) => tool.type === "file_search"
                            )
                              ? "ellipse-active"
                              : ""
                          }`}
                        ></div>
                      </div>
                    </div>
                  </div>

                  {activeAssistant.tools.some(
                    (tool) => tool.type === "file_search"
                  ) && (
                    <AssistantFileUpload
                      files={activeAssistant.files}
                      updateFiles={(files) => this.handleFilesChange(files)}
                    />
                  )}
                </>
              )}
              <div className="bookish-input-group mt-7">
                <p className="bookish-input-label">
                  Personality Mode <span className="required">*</span>
                </p>
                <div className="grid grid-cols-2 gap-4">
                  <DragDrop
                    list={activeAssistant.sample_prompts}
                    onReorder={this.handleReorder}
                  >
                    {(value, index) => (
                      <div style={{ width: "23rem" }}>
                        <div
                          className="sample-prompt flex justify-end items-center"
                          style={{ padding: "1rem" }}
                        >
                          <p className="mr-auto">{value}</p>
                          <span
                            onClick={() =>
                              this.setState({
                                CustomPromptActiveAssistant:
                                  activeAssistant._id as string,
                                CustomPromptActive: value,
                                customPromptOpen: true,
                              })
                            }
                          >
                            <img
                              src="/assets/images/file-add.svg"
                              alt=""
                              style={{
                                height: "2rem",
                                marginRight: "1.5rem",
                                cursor: "pointer",
                              }}
                            />
                          </span>
                          <img
                            className="cursor-pointer"
                            onClick={() => this.removeSamplePrompt(index)}
                            src="/assets/images/close-icon.svg"
                            style={{ height: "1rem" }}
                            alt=""
                          />
                        </div>
                      </div>
                    )}
                  </DragDrop>
                </div>

                <input
                  type="text"
                  className="bookish-input-field"
                  value={this.state.currentPrompts[this.state.activeTab]}
                  onChange={this.handlePromptInputChange}
                  onKeyPress={this.handleAddSamplePrompt}
                  placeholder="Type sample prompt here."
                />
              </div>

              <div className="bookish-input-group mt-8">
                <p className="bookish-input-label">
                  Assign to a subscription plan
                  <span className="required">*</span>
                </p>
                <div className="grid grid-cols-2 gap-4">
                  {this.plans.map((plan, index) => (
                    <div key={index} className="relative flex gap-x-3">
                      <div className="flex h-6 items-center">
                        <input
                          id={`plan-${plan}-${index}`}
                          type="checkbox"
                          className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                          checked={activeAssistant.for_plan.includes(plan)}
                          onChange={() => this.togglePlan(plan)}
                        />
                      </div>
                      <div className="text-sm leading-6">
                        <label
                          htmlFor={`plan-${plan}-${index}`}
                          className="font-medium text-gray-900"
                        >
                          {this.plansMapper[plan]}
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>

        {showDeleteModal && (
          <DeleteModal
            title="Deleting assistant"
            message="Are you absolutely sure you want to delete the current assistant? This action is not reversible."
            close_modal={() => this.setState({ showDeleteModal: false })}
            delete_it={() => {
              this.deleteAssistant();
            }}
          />
        )}

        {this.state.CustomPromptActive && (
          <CustomPromptModal
            isOpen={this.state.customPromptOpen}
            onClose={() => {
              this.setState({ customPromptOpen: false });
            }}
            characterId={this.props.characterId}
            assistantId={this.state.CustomPromptActiveAssistant}
            prompt={this.state.CustomPromptActive}
          ></CustomPromptModal>
        )}
      </div>
    );
  }
}

export default AssistantForm;
